import Block from "./Block";

export default class References extends Block {

    constructor(root) {
        super(root);

        this.sliderRoot = this.root.find(".ref__images");
        this.refCards = this.root.find(".references__list");

        if (this.sliderRoot.length) {
            this.initSlider();
        }

        if (this.refCards.length) {
            this.initCardSlider();
        }
    }


    initSlider() {
        this.sliderRoot.slick({
            arrows: true,
            prevArrow: "<div type=\"button\" class=\"slick-button slick-prev\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></div>",
            nextArrow: "<div type=\"button\" class=\"slick-button slick-next\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></div>",
        });
    }

    initCardSlider() {
        this.refCards.slick({
            arrows: true,
            prevArrow: "<div type=\"button\" class=\"ref__button slick-button slick-prev\"><i class=\"fa fa-chevron-left\" aria-hidden=\"true\"></i></div>",
            nextArrow: "<div type=\"button\" class=\"ref__button slick-button slick-next\"><i class=\"fa fa-chevron-right\" aria-hidden=\"true\"></i></div>",
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 2
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]

        });
    }
}
